//Libs
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core';
//Componentes
import ImageInput from '../ImageInput';
//Úteis
import formatarUrlImagem from '../../utils/formatarUrlImagem';
//Modelos
import QuestionarioOpcaoResposta from '../../models/QuestionarioOpcaoResposta';
import ErroQuestionarioOpcao from '../../models/ErroQuestionarioOpcao';

const styles = (theme) => ({
    imageField: {
        minWidth: '0px'
    },
    textField: {
        minWidth: theme.spacing(15)
    }
});

/**
 * Componente para opções de resposta de texto e imagem
 */
class QuestaoEscolhaOpcaoTexto extends Component {
    constructor(props) {
        super(props);
        //Bindings
        this.handleTextFieldChange = this.handleTextFieldChange.bind(this);
        this.handleImagemChange = this.handleImagemChange.bind(this);
        this.handleImagemError = this.handleImagemError.bind(this);
        //Estado inicial
        this.state = {
            erroImagem: props.erros.imagem, //Inicia o erro da imagem com a mensagem recebida
        };
    }

    /**
     * Trata a alteração na descrição da opção de resposta
     * @param {*} event Objeto com os dados do evento
     */
    handleTextFieldChange(event) {
        //Copia a resposta
        const opcao = QuestionarioOpcaoResposta.clone(this.props.opcao);
        //Preenche a descrição
        opcao.descricao = event.target.value;
        //Dispara o evento de alteração
        this.dispararEventoChange(opcao);
    }

    /**
     * Trata a alteração na imagem selecionada
     * @param {*} target Campo que originou a alteração
     * @param {String} value Novo valor do campo
     */
    handleImagemChange(target, value) {
        //Copia a opção de resposta
        const opcao = QuestionarioOpcaoResposta.clone(this.props.opcao);
        //Preenche a imagem
        opcao.novaImagem = value;
        //Dispara o evento de alteração
        this.dispararEventoChange(opcao);
        //Limpa a mensagem de erro
        this.setState({ erro: '' });
    }

    /**
     * Trata o evento de erro na seleção de imagens
     * @param {*} target Componente que gerou o evento
     * @param {String} mensagem Mensagem de erro do componente
     */
    handleImagemError(target, mensagem) {
        //Atualiza o estado do componente com o erro recebido
        this.setState({ erroImagem: mensagem });
    }

    /**
     * Dispara o evento de alteração da opção de resposta
     * @param {QuestionarioOpcaoResposta} opcao Objeto opção com os dados alterados
     */
    dispararEventoChange(opcao) {
        const { readOnly } = this.props;
        //Verifica se o evento está preenchido
        if (!readOnly && this.props.onChange)
            this.props.onChange(opcao);
    }

    render() {
        const { opcao, erros, classes } = this.props;
        const { erroImagem } = this.state;

        let imagePlaceholder = '';
        if (opcao.imagem)
            imagePlaceholder = formatarUrlImagem(opcao.imagem);

        return (
            <Fragment>
                <Grid item className={classes.imageField} sm={2} >
                    <ImageInput 
                        name="imagem"
                        label=""
                        value={opcao.novaImagem}
                        placeholder={imagePlaceholder}
                        errorMessage={erroImagem}
                        onChange={this.handleImagemChange}
                        onError={this.handleImagemError}
                        size="small"
                    />
                </Grid>
                <Grid item xs className={classes.textField} >
                    <TextField
                        name="descricao" 
                        label="" 
                        type="text" 
                        placeholder="Opção de resposta" 
                        variant="standard" 
                        size="small"
                        fullWidth 
                        required
                        autoFocus={this.props.focoAutomatico}
                        error={!!erros.descricao}
                        helperText={erros.descricao}
                        value={opcao.descricao} 
                        onChange={this.handleTextFieldChange} 
                    />        
                </Grid>
            </Fragment>
        );    
    }

}

QuestaoEscolhaOpcaoTexto.propTypes = {
    /** Dados da opção de resposta a ser editada */
    opcao: PropTypes.instanceOf(QuestionarioOpcaoResposta).isRequired,
    /** Mensagens de erro da opção de resposta */
    erros: PropTypes.instanceOf(ErroQuestionarioOpcao),
    /** Indica se o componente terá o foco ao ser criado */
    focoAutomatico: PropTypes.bool,
    /** Evento disparado quando alguma alteração é realizada na reposta */
    onChange: PropTypes.func,
    /** Identifica se o componente é somente leitura e não permite alterações */
    readOnly: PropTypes.bool,
    /** Classes CSS personalizadas */
    classes: PropTypes.shape({
        imageField: PropTypes.string,
        textField: PropTypes.string,
    })
};

QuestaoEscolhaOpcaoTexto.defaultProps = {
    erros: new ErroQuestionarioOpcao(),
    readOnly: false
};

export default withStyles(styles)(QuestaoEscolhaOpcaoTexto);